import { render, staticRenderFns } from "./BaseWelcomePanel.vue?vue&type=template&id=712e1fbc&"
import script from "./BaseWelcomePanel.vue?vue&type=script&lang=js&"
export * from "./BaseWelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseWelcomePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports